"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectField = void 0;
const react_1 = __importDefault(require("react"));
const SelectField = ({ field, value, onChange, error, disabled, lookups }) => {
    let options = [];
    if (field.options) {
        options = field.options;
    }
    else if (field.lookup && lookups?.[field.lookup]) {
        options = lookups[field.lookup];
    }
    return (react_1.default.createElement("div", { className: "field-group" },
        react_1.default.createElement("label", { className: "field-label" },
            field.label,
            field.required && react_1.default.createElement("span", { className: "required" }, "*")),
        field.tooltip && react_1.default.createElement("span", { className: "field-hint" }, field.tooltip),
        react_1.default.createElement("select", { className: `field-input${error ? ' error' : ''}`, name: field.key, value: value != null ? String(value) : '', onChange: (e) => onChange(field.key, e.target.value || null), disabled: disabled },
            react_1.default.createElement("option", { value: "" }, "-- Select --"),
            options.map((opt) => (react_1.default.createElement("option", { key: opt.value, value: String(opt.value) }, opt.label)))),
        error && react_1.default.createElement("div", { className: "field-error" }, error)));
};
exports.SelectField = SelectField;
